import {Component, OnInit} from '@angular/core';
import {IAppState} from '@app/core/store/state/app.state';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {selectDayNotes, selectSelectedDate} from '@app/core/store/selectors/daynotes.selectors';
import {DayNote} from '@app/core/models/day-note.model';
import {getCurrentState} from '@app/core/helpers';
import {SetSelectedDayNote} from '@app/core/store/actions/daynotes.actions';
import {Moment} from 'moment';
import {Department} from '@app/core/models/department.model';
import {selectDepartment, selectUser} from '@app/core/store/selectors/session.selectors';
import {MatDialogRef} from '@angular/material/dialog';
import {AuthService} from '@app/core/services/auth.service';
import {User} from '@app/core/models/user.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';

@Component({
	selector: 'app-day-notes-popup',
	templateUrl: './day-notes-popup.component.html',
	styleUrls: ['./day-notes-popup.component.scss'],
})
export class DayNotesPopupComponent implements OnInit {
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	public selectedDate$: Observable<Moment> = this.store.select(selectSelectedDate);
	public dayNotes$: Observable<DayNote[]> = this.store.select(selectDayNotes);
	public selectedDepartment$: Observable<Department> = this.store.select(selectDepartment);
	public user$: Observable<User> = this.store.select(selectUser);

	public dayNotes: DayNote[] = [];

	constructor(
		public store: Store<IAppState>,
		public dialogRef: MatDialogRef<DayNotesPopupComponent>,
		public authService: AuthService,
		private interService: InternationalizationService
	) {
		this.editNote = this.editNote.bind(this);
		this.selectedDate$.subscribe(date => {
			if (date === undefined) {
				return;
			}
			this.setNotesAndActions();
		});
		this.dayNotes$.subscribe(dayNotes => {
			this.setNotesAndActions();
		});
	}

	public setNotesAndActions(): any {
		const dayNotes = getCurrentState(this.store).dayNotes.dayNotes;
		const date = getCurrentState(this.store).dayNotes.selectedDate;
		this.dayNotes = dayNotes.filter(d => d.start.format('YYYY-MM-DD') === date.format('YYYY-MM-DD'));
		this.dayNotes = this.dayNotes.map(d => {
			d.actions = [];
			if (d.user.id === this.authService.currentUser.id) {
				d.actions.push({
					text: this.interService.translate.instant('DAY_NOTES.EDIT'),
					onClick: this.editNote,
					clickValue: d,
				});
			}

			return d;
		});
	}

	public ngOnInit(): void {
	}

	public close(): void {
		this.dialogRef.close();
	}

	public createNew(): void {
		this.store.dispatch(new SetSelectedDayNote(null, getCurrentState(this.store).dayNotes.selectedDate));
	}

	public editNote(dayNote: DayNote): void {
		this.store.dispatch(new SetSelectedDayNote(dayNote, dayNote.start));
	}
}
